import { PetPolicyFilter } from '../api/models';

export interface Filters {
  search: string;
  city: string;
  guests: number;
  adults: number;
  children: number;
  withPets: boolean;
  propertyTypeIds: number[];
  priceMin: number | null;
  priceMax: number | null;
  petPolicy: PetPolicyFilter | null;
  minStay: number | null;
  amenityIds: number[];
  sortBy: string;
  sortOrder: 'ASC' | 'DESC';
  dateFrom: Date | null;
  dateTo: Date | null;
}

export const DEFAULT_FILTERS: Filters = {
  search: '',
  city: '',
  guests: 0,
  adults: 0,
  children: 0,
  withPets: false,
  propertyTypeIds: [],
  priceMin: null,
  priceMax: null,
  petPolicy: null,
  minStay: null,
  amenityIds: [],
  sortBy: 'relevance',
  sortOrder: 'DESC',
  dateFrom: null,
  dateTo: null,
};

export interface SortOption {
  sortBy: string;
  sortOrder: 'ASC' | 'DESC';
}

/**
 * Accepted values for the shareable `?sort=` URL param.
 * Keys are lower-cased so the param is case-insensitive. Includes both the
 * canonical `sortBy_sortOrder` form used by the sort dropdown and friendly
 * aliases that are nicer to share (e.g. `?sort=newest`).
 */
const SORT_PARAM_MAP: Record<string, SortOption> = {
  relevance_desc: { sortBy: 'relevance', sortOrder: 'DESC' },
  createdat_desc: { sortBy: 'createdAt', sortOrder: 'DESC' },
  name_asc: { sortBy: 'name', sortOrder: 'ASC' },
  name_desc: { sortBy: 'name', sortOrder: 'DESC' },
  // Friendly aliases
  recommended: { sortBy: 'relevance', sortOrder: 'DESC' },
  newest: { sortBy: 'createdAt', sortOrder: 'DESC' },
};

/** Parse a `?sort=` URL value into a sort option, or null when unrecognised. */
export function parseSortParam(value: string | null | undefined): SortOption | null {
  if (!value) return null;
  return SORT_PARAM_MAP[value.trim().toLowerCase()] ?? null;
}

/** Serialize a sort option to the value written into the `?sort=` URL param. */
export function serializeSortParam(sortBy: string, sortOrder: 'ASC' | 'DESC'): string {
  if (sortBy === 'createdAt' && sortOrder === 'DESC') return 'newest';
  if (sortBy === 'relevance' && sortOrder === 'DESC') return 'recommended';
  return `${sortBy}_${sortOrder}`;
}
